export const logger = (...text) => {
  console.log(...text);
};
